// <auto-generated />
// assembly: SecureTokenService.Generator.TypeScript, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
// generator: SecureTokenService.Generator.TypeScript.ModelsSourceGenerator

export interface IVaccinationProfileQuery {
    subject: string,
    pin: string,
}

export class VaccinationProfileQuery implements IVaccinationProfileQuery {
    subject: string;
    pin: string;
    
    constructor(subject: string, pin: string) {
        this.subject = subject;
        this.pin = pin;
    }
}